import SweetAlert from "sweetalert2";
import { LI } from '../../../../../../AbstractElements';
import { Href } from '../../../../../../Constants/Constants';
import { useAppDispatch } from '../../../../../../ReduxToolkit/Hooks';
import { deletedUser, setTempId } from '../../../../../../ReduxToolkit/Reducers/ContactReducer';
import { EditDeleteLinkProps, UserCallbackUserType, UserProps } from '../../../../../../Types/ContactType';

export const EditDeleteLink:React.FC<EditDeleteLinkProps> = ({ selectedUser, userEditCallback }) => {
    const dispatch = useAppDispatch();
    const editUsers = (usersData: UserCallbackUserType) => {
        if (usersData.id !== undefined) {
            dispatch(setTempId(usersData.id));
            userEditCallback(true, usersData as UserProps);
        }
    };
    const onDeleteUser = (userId: number | undefined) => {
        if (userId !== undefined) {
            SweetAlert.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this imaginary file!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "cancel",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    dispatch(deletedUser(userId));
                    SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
                } else {
                    SweetAlert.fire("Your imaginary file is safe!");
                }
            });
        } else { console.error("User ID is undefined"); }
    };
    return (
        <>
            <LI><a href={Href} onClick={() => editUsers(selectedUser)}>{'Edit'}</a></LI>
            <LI><a href={Href} onClick={() => onDeleteUser(selectedUser.id)}>{'Delete'}</a></LI>
        </>
    )
}